import {HttpRequest,HttpMethod} from "./http";

class ProductProvider extends HttpRequest {
	// Show product for create order
	ListProductWithStock(params) {
        return this.request(HttpMethod.Post,`/api/v1/orders/product`,params );
    }


	// CRUD Product
	ProductCreate(params) {
		return this.request(HttpMethod.Post,`/api/v1/products`,params );
	}

	// V3 create/update carry the App shopping-page fields (app_enable, app_tag,
	// app_discount, app_discount_start/end) + stock_sync_enabled on top of the
	// V1 payload (incl. visibility/price_tiers) — V1 drops them on save.
	ProductCreateV3(params) {
		return this.request(HttpMethod.Post,`/api/v3/products`,params );
	}

	ProductUpdateV3(id,params) {
		return this.request(HttpMethod.Put,`/api/v3/products/${id}`,params );
	}

	ProductListV3(params) {
		return this.request(HttpMethod.Get,`/api/v3/products`,params );
	}
	ProductListV1(params) {
		return this.request(HttpMethod.Get,`/api/v1/products`,params );
	}

	ProductDetail(id) {
		return this.request(HttpMethod.Get,`/api/v1/products/${id}` );
	}

	ProductSkuList(params) {
		return this.request(HttpMethod.Get,`/api/v1/productssku`,params );
	}

	ProductUpdate(id,params) {
		return this.request(HttpMethod.Put,`/api/v1/products/${id}`,params );
	}

	ProductPlatformUpdate(id,params) {
		return this.request(HttpMethod.Put,`/api/v1/products/platform/${id}`,params );
	}
	

	ProductDelete(id) {
		return this.request(HttpMethod.Delete,`/api/v1/products/${id}`);
	}


	SKURandomList(params) {
		return this.request(HttpMethod.Get,`/api/v1/products/random`,params );
	}

	SKURandomCreate(params) {
		return this.request(HttpMethod.Post,`/api/v1/products/random`,params );
	}

	SKURandomDelete(id) {
		return this.request(HttpMethod.Delete,`/api/v1/products/random/${id}`);
	}

	StockSyncToggle(id, params) {
		return this.request(HttpMethod.Patch,`/api/v3/products/${id}/stock-sync`, params);
	}

	SyncProduct(params) {
		return this.request(HttpMethod.Post,`/api/v3/products/sync`, params);
	}

	CalculateStock(params) {
		return this.request(HttpMethod.Get,`/api/v3/products/calculate`, params);
	}

	PackingOrders(productID) {
		return this.request(HttpMethod.Get,`/api/v3/products/${productID}/packing-orders`);
	}

	PackingOrdersList(productID, params) {
		return this.request(HttpMethod.Get,`/api/v3/products/${productID}/packing-orders/list`, params);
	}

}

export default ProductProvider